import { render } from "./CardPanel.vue?vue&type=template&id=6f0bf58e&scoped=true"
import script from "./CardPanel.vue?vue&type=script&lang=js"
export * from "./CardPanel.vue?vue&type=script&lang=js"

import "@/Common/Styles/profilePanels.scss?vue&type=style&index=0&id=6f0bf58e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f0bf58e"]])

export default __exports__